import { updateItemInCollection } from "directus/src/operations";

export async function updateCostMaster({ item, costmasterId }) {
  try {
    const data = await updateItemInCollection("cost_master", costmasterId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
